import { noop } from 'lodash-es';
import { type ReactNode, useId, useRef } from 'react';
import { useEventListener } from 'usehooks-ts';
import { useShallow } from 'zustand/react/shallow';
import ActionSheetPrompt from '@/components/common/prompts/action-sheet-prompt';
import ContextMenuPrompt from '@/components/common/prompts/context-menu-prompt';
import DialogPrompt from '@/components/common/prompts/dialog-prompt';
import FormPrompt from '@/components/common/prompts/form-prompt';
import useUserPlatform from '@/hooks/use-user-platform';
import { clearPrompts, usePrompterStore } from '@/stores/prompter';

export default function AppPrompter() {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const promptId = useId();
  const prompt = usePrompterStore(useShallow((s) => Object.values(s.prompts).at(0)));
  const { isEmbedded } = useUserPlatform();

  useEventListener('wheel', () => clearPrompts(false));
  useEventListener('resize', () => {
    prompt?.type !== 'form' && !isEmbedded ? clearPrompts(false) : noop();
  });

  let content: ReactNode;
  switch (prompt?.type) {
    case 'dialog':
    case 'alert':
      content = <DialogPrompt prompt={prompt} />;
      break;
    case 'action-sheet':
      content = <ActionSheetPrompt prompt={prompt} />;
      break;
    case 'form':
      content = <FormPrompt prompt={prompt} />;
      break;
    case 'context-menu':
      content = <ContextMenuPrompt prompt={prompt} />;
      break;
    default:
      content = null;
      break;
  }

  return (
    <div
      ref={containerRef}
      id={`app-prompter-${promptId}`}>
      {content}
    </div>
  );
}
